import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MasterDataService } from '../../../../core/services/master-data.service';
import { SchoolAndTrainingService } from '../../../../core/services/school-and-training.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { ICountry, IModuleSchoolLabel, IRegisterModulesList } from '../../../../core/models';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { map, tap } from 'rxjs/operators';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-modules-school',
  templateUrl: './modules-school.component.html',
  styleUrls: ['./modules-school.component.scss']
})
export class ModulesSchoolComponent implements OnInit {
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  moduleLblText: IModuleSchoolLabel;
  public position = 'top';
  registrationForm: FormGroup;
  countries: any;
  states: any;
  data: any;
  registerLocationList: any = [];
  saveInProcess: boolean;
  pdfUrl: string = "";
  constructor(private formBuilder: FormBuilder, private trainingService: SchoolAndTrainingService, private masterService: MasterDataService,
    private appNotifyService: AppNotifyService, private languageTranslationService: LanguageTranslationService, private sanitizer: DomSanitizer, private userService: UserService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.initilizeForm();
    this.loaadDetails();
    this.masterService.GetCountries().pipe(tap((countries: ICountry[]) => {
      this.masterService.countries = countries as ICountry[];
    })).subscribe((countries: ICountry[]) => {
      this.countries = countries as ICountry[];
    })
    //this.pdfUrl = environment.imageUrl + "/ResourceCenter/content/KawneerTrainingWaiver.pdf";

  }
  //#region intiize form controls and load details
  trainingPdfUrl: any = null;
  registrationPdfUrl: any = null;
  loaadDetails() {
    const body = {
      languageCode: localStorage.getItem("language")
    }
    this.trainingService.getModulesSchoolDetails(body).subscribe(response => {
    
      if (response.length > 0) {
        this.data = response[0];
        if (this.data.trainingUrlPath) {
          const url = environment.imageUrl + this.data.trainingUrlPath;
          this.trainingPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        if (this.data.registrationUrlPath) {
          const url = environment.imageUrl + this.data.registrationUrlPath;
          this.pdfUrl = url;
          this.registrationPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        
      }
    })
    this.masterService.GetCountries().subscribe(response => {
      this.countries = response;
    })
  }
  initilizeForm() {
    this.registrationForm = this.formBuilder.group({
      firstName: new FormControl(),
      lastName: new FormControl(),
      jobTitle: new FormControl(),
      companyName: new FormControl(),
      address: new FormControl(),
      city: new FormControl(),
      comments: new FormControl(),
      email: new FormControl(),
      phoneNumber: new FormControl(),
      faxNumber: new FormControl(),
      country: new FormControl(),
      state: new FormControl(),
      zipCode: new FormControl(),
    })
  }
  //#endregion

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "modulesSchoolInformationLbl" },
      { controlName: "trainingModuleDescriptionLbl" },
      { controlName: "moduleDescriptionLbl" },
      { controlName: "locationInformationLbl" },
      { controlName: "registrationLbl" },
      { controlName: "onlineRegistrationLbl" },
      { controlName: "firstNameLbl" },
      { controlName: "lastNameLbl" },
      { controlName: "jobTitleLbl" },
      { controlName: "companyNameLbl" },
      { controlName: "addressLbl" },
      { controlName: "cityLbl" },
      { controlName: "commentLbl" },
      { controlName: "emailLbl" },
      { controlName: "phoneNumber" },
      { controlName: "faxNumberLbl" },
      { controlName: "countryLbl" },
      { controlName: "stateLbl" },
      { controlName: "zipCodeLbl" },
      { controlName: "selectModuleLbl" },
      { controlName: "continueLbl" },
      { controlName: "submitLbl" },
      { controlName: "cancelLbl" },
      { controlName: "invalidEmail" },
      { controlName: "moduleNote" },
      { controlName: "onlineRegistrationNote" },
      { controlName: "invalidPhoneLbl" },
      { controlName: "pdfLinkLbl" },
      { controlName: "liabilityWaiverLbl" },
      { controlName: "invalidLocation" },
    ];
    const componentName = "modulesschool";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.moduleLblText = response[response.length - 1];
    }
  }

  //#endregion
  //#region label/variable declaration
  public modulesSchool = {
    modulesSchoolInformationLbl: "MODULES SCHOOL INFORMATION",
    trainingModuleDescriptionLbl: "Training Modules",
    moduleDescriptionLbl: "Module Descriptions",
    locationInformationLbl: "Location Information",
    registrationLbl: "Registration",
    liabilityWaiverLbl: "Liability Waiver",
    pdfLinkLbl: "Click here to download PDF",
    onlineRegistrationLbl: 'ONLINE REGISTRATION',
    firstNameLbl: 'First Name',
    lastNameLbl: 'Last Name',
    jobTitleLbl: 'Job Title',
    companyNameLbl: 'Company Name',
    addressLbl: 'Address',
    cityLbl: 'City',
    commentLbl: 'Comments',
    emailLbl: 'Email',
    phoneNumber: 'Phone Number',
    faxNumberLbl: 'Fax Number',
    countryLbl: 'Country',
    stateLbl: 'State',
    zipCodeLbl: 'Zip Code',
    selectModuleLbl: 'Please select location',
    continueLbl: 'Continue',
    submitLbl: 'Submit',
    cancelLbl: 'Cancel',
    moduleNote: '*Note: We suggest you enroll early. Sorry, we cannot reserve or confirm enrollment without application and payment.',
    onlineRegistrationNote: '*You must register on-line to receive special KawneerDirect price. Special KawneerDirect price: $25 KawneerDirect Discount per Location.',
    isEmptyFirstName: false,
    isEmptyJobTitle: false,
    isEmptyCompanyName: false,
    isEmptyPhoneNumber: false,
    isInvalidPhoneNumber: false,
    isEmptyEmail: false,
    isInvalidEmail: false,
    isInvalidLocation: false,
    invalidEmail: "Email address is invalid",
    invalidLocation: "Please select at least one location",
    isSubmitted: false,
    invalidPhoneLbl: 'Phone number length should be minimum 10',
  }
  //#endregion

  countySelectionChange(event) {
    if (event) {
      this.states = event.states;
    }
  }
  //#region validation
  public checkEmail(email) {
    const regExp = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return regExp.test(String(email).toLowerCase());
  }
  emailLeave() {
    const controls = this.registrationForm.controls;
    if (controls.email.value) {
      const res = this.checkEmail(controls.email.value);
      if (!res) {
        this.modulesSchool.isInvalidEmail = true;
        this.modulesSchool.isEmptyEmail = true;
      } else {
        this.modulesSchool.isInvalidEmail = false;
        this.modulesSchool.isEmptyEmail = false;
      }
    }
    else {
      this.modulesSchool.isInvalidEmail = false;
      this.modulesSchool.isEmptyEmail = true;
    }
  }
   validateModulesSchoolForm(): boolean {
    let isValid = true;
    const controls = this.registrationForm.controls;
    if (this.modulesSchool.isSubmitted) {
      if (controls.firstName.value) {
        this.modulesSchool.isEmptyFirstName = false;
      } else {
        this.modulesSchool.isEmptyFirstName = true;
        isValid = false;
      }
      if (controls.companyName.value) {
        this.modulesSchool.isEmptyCompanyName = false;
      } else {
        this.modulesSchool.isEmptyCompanyName = true;
        isValid = false;
      }
      if (controls.jobTitle.value) {
        this.modulesSchool.isEmptyJobTitle = false;
      } else {
        this.modulesSchool.isEmptyJobTitle = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.checkEmail(controls.email.value);
        if (!res) {
          this.modulesSchool.isInvalidEmail = true;
          this.modulesSchool.isInvalidEmail = true;
          isValid = false;
        } else {
          this.modulesSchool.isInvalidEmail = false;
          this.modulesSchool.isEmptyEmail = false;
        }
      } else {
        this.modulesSchool.isEmptyEmail = true;
        isValid = false;
      }
      if (controls.phoneNumber.value) {
        this.modulesSchool.isEmptyPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.modulesSchool.isEmptyPhoneNumber = true;
          this.modulesSchool.isInvalidPhoneNumber = true;
          isValid = false;
        } else {
          this.modulesSchool.isInvalidPhoneNumber = false;
          this.modulesSchool.isInvalidPhoneNumber = false;
        }
      } else {
        this.modulesSchool.isEmptyPhoneNumber = true;
        this.modulesSchool.isInvalidPhoneNumber = false;
        isValid = false;
      }
      if (this.registerLocationList.length == 0) {
        this.modulesSchool.isInvalidLocation = true;
        isValid = false;
      } else {
        this.modulesSchool.isInvalidLocation = false;
      }
    }
    return isValid;
  }
  //#endregion
  //#region reset form
  resetForm() {
    this.registrationForm.reset();
    this.registerLocationList = [];
    this.modulesSchool.isSubmitted = false;
    this.modulesSchool.isEmptyFirstName = false;
    this.modulesSchool.isEmptyCompanyName = false;
    this.modulesSchool.isEmptyJobTitle = false;
    this.modulesSchool.isEmptyFirstName = false;
    this.modulesSchool.isEmptyPhoneNumber = false;
    this.modulesSchool.isInvalidPhoneNumber = false;
    this.modulesSchool.isEmptyEmail = false;
    this.modulesSchool.isInvalidEmail = false;
    this.modulesSchool.isInvalidLocation = false;
  }
  //#endregion
  //#region submit button operation
  submit() {
    this.modulesSchool.isSubmitted = true;
    if (!this.validateModulesSchoolForm()) {
      return;
    }
    const controls = this.registrationForm.controls;
    const body = {
      id: 0,
      registrationId: "",
      firstName: controls.firstName.value,
      lastName: controls.lastName.value,
      jobTitle: controls.jobTitle.value,
      companyName: controls.companyName.value,
      address: controls.address.value,
      city: controls.city.value,
      comments: controls.comments.value,
      email: controls.email.value,
      phoneNumber: controls.phoneNumber.value ? controls.phoneNumber.value.toString() : "",
      faxNumber: controls.faxNumber.value,
      country: controls.country.value,
      state: controls.state.value.stateDescription,
      zipCode: controls.zipCode.value,
      modulesList: this.registerLocationList,
      userName: this.userService.readUserObject.userName,
      customerName: this.userService.readUserObject.customerName,
      customerNumber: this.userService.readUserObject.customerNumber
    }
    this.trainingService.registerModulesSchool(body).subscribe(response => {
      this.resetForm();
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
    })
  }
  //#endregion
  modulesCheck(val) {
    debugger;
    const rowIndex = this.data.moduleSchoolLocationDetails.findIndex(r => r.locationId === val.locationId); //getting row index
    if (this.registerLocationList.length > 0) {
      const isExist = this.registerLocationList.find(p => (p.locationId === val.locationId && p.isChecked === true)); //checking if switch is unchecked and if exist 
      if (isExist) {
        const index = this.registerLocationList.findIndex(p => (p.locationId === val.locationId && p.isChecked === true));
        this.registerLocationList.splice(index, 1);
        
        if (this.registerLocationList.length == 0) {
          this.modulesSchool.isInvalidLocation = true;
        } else {
          this.modulesSchool.isInvalidLocation = false;
        }
        return;
      }
    }
    const locationList = { id: 0, registrationId: "", locationId: this.data.moduleSchoolLocationDetails[rowIndex].locationId, isChecked: true, moduleLocationId: "", moduleSchoolId: this.data.moduleSchoolLocationDetails[rowIndex].moduleSchoolId };
    this.registerLocationList.push(locationList);
    //pushing the list
    if (this.registerLocationList.length == 0) {
      this.modulesSchool.isInvalidLocation = true;
    } else {
      this.modulesSchool.isInvalidLocation = false;
    }
  }

  //#region panel change
  continueToNextPanel() {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.panel.childrenItems[1].expanded = true;
    this.panel.childrenItems[1].selected = true;
  }

  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  //#endregion
  onTabSelected(e) {

  }
}
